Vue.component('factionleaderboard', {
    template: templates.factionLeaderBoard,
    data() {
      return {
        model: {
     
        }
      }
    },
    mounted() {
      const c = this;
     
    },
    methods: {
     
  
    
    
    }
  });